// Utils
import { isLine } from '../../common/elements/utils/elementTypeUtils';
import { getElementId } from '../../common/elements/utils/elementPropertyUtils';
import { inboxDropResultFn } from '../element/dnd/dropResultFn';

// Constants
import { ELEMENT_DND_TYPE } from '../../common/elements/elementConstants';

// Types
import type { MNElement, MNElementLocation } from '../../common/elements/elementModelTypes';
import type { Point } from '../../common/maths/geometry/pointTypes';

export type InboxDropElement = Partial<MNElement>;

export type InboxDropMonitor = {
    getItem: () => { draggedElements?: InboxDropElement[] };
    getItemType: () => string | symbol | null;
};

/**
 * The full prop bag is forwarded to `inboxDropResultFn`, which reads more of it than this module names.
 */
export type InboxDropLocationProps = {
    element: InboxDropElement;
    [key: string]: unknown;
};

export type InboxDropResult = {
    location?: MNElementLocation;
    acceptedElementIds?: string[];
    dropTargetElement?: InboxDropElement;
    dropState?: unknown;
    transactionId?: number;
    zoomScaleOnDropTarget?: number;
    clientOffset?: Point | null;
};

export default (
    props: InboxDropLocationProps,
    monitor: InboxDropMonitor,
    domNode?: HTMLElement | null,
): InboxDropResult => {
    const dropResult = inboxDropResultFn(props, monitor, domNode);

    const itemType = monitor.getItemType();

    if (itemType !== ELEMENT_DND_TYPE) return { ...dropResult };

    // Can't drop lines onto the inbox.
    // NOTE: Collapsed comment threads are accepted. The Inbox displays comment threads expanded whatever their
    //  collapsed flag says (see `showCollapsedSelector`), and the flag is left alone so that moving the comment
    //  back onto a Canvas restores its pin - matching how Quick Notes and the Trash already behave.
    const { draggedElements = [] } = monitor.getItem();
    const acceptedElementIds = draggedElements.filter((el) => !isLine(el)).map((el) => getElementId(el));

    return {
        ...dropResult,
        acceptedElementIds,
    };
};
